export class Color {
  private static _values: Color[] = [];
  private static _lookup: Map<number, Color> = new Map();

  static fromId(id: number) {
    const instance = Color._lookup.get(id);
    if (instance === undefined) {
      throw new Error('Not a valid Color.id: ' + id);
    }
    return instance;
  }

  static values(): Color[] {
    return [...Color._values];
  }

  // ---

  public readonly id: number;
  public readonly label: string;

  constructor(id: number, label: string) {
    this.id = id;
    this.label = label;
    Color._values.push(this);
    Color._lookup.set(id, this);
  }

  toJson(): { id: number; name: string } {
    return { id: this.id, name: this.label };
  }

  toString(): string {
    return '<Color: ' + this.id + ", label='" + this.label + "'>";
  }
}
